
var id = "add";
var markup = "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"add\">\n    <title>19. Speed Dial/02. Elements/Item备份 2@2x</title>\n    <defs>\n        <polygon id=\"add_path-1\" points=\"32 18.2857143 18.2857143 18.2857143 18.2857143 32 13.7142857 32 13.7142857 18.2857143 0 18.2857143 0 13.7142857 13.7142857 13.7142857 13.7142857 0 18.2857143 0 18.2857143 13.7142857 32 13.7142857\" />\n    </defs>\n    <g id=\"add_微信管理（fa）\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"add_微信管理-/-自动回复-/关注后自动回复（空规则）\" transform=\"translate(-504.000000, -416.000000)\">\n            <g id=\"add_区块-表单\" transform=\"translate(280.000000, 245.000000)\">\n                <g id=\"add_编组-2\" transform=\"translate(32.000000, 99.000000)\">\n                    <g id=\"add_34.-Icons/filled/content/add_24px\" transform=\"translate(192.000000, 72.000000)\">\n                        <mask id=\"add_mask-2\" fill=\"white\">\n                            <use xlink:href=\"#add_path-1\" />\n                        </mask>\n                        <use id=\"add_icon/content/add_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#add_path-1\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
